<template lang="pug">
  .timeline(ref="timeline")
    .vehicleLimit.caption.grey--text.text--darken-2() Vehicle Limit: {{$store.getters["vehicles/devices/getCurrentDevice"].max_speed}} Kph
    .instructions.caption.grey--text.text--darken-2() Scrub the timeline with a dot [{{$store.state.timeline.avl_data.length}}]
    .grey.lighten-1( style="padding: 0px 25px 0px 20px")
      chart-timeline-graph.grey.lighten-1( style="height:100px;width:100%") hello world
      .grey.darken-2(width="100%")
        chart-progress-bar(v-model="thePercentage")
    v-progress-linear(:indeterminate="$store.state.timeline.isLoading")
    #mapTimeline(:key="$store.state.global_map_key" :style="{'height':`${height-94}px`}")
      .hud()
        .d-flex.flex-column(v-if="currentAvlRecord" )
          map-hud(label="Speed",:value="`${currentAvlRecord.s} Kph`")
          map-hud(label="Odometer",:value="`${currentAvlRecord.o == null ? '-':(currentAvlRecord.o/1000.0).toFixed(2)}`")
          map-hud(label="Distance",:value="`${getDistance()} Km`")
          map-hud(label="Ignition",:value="`${currentAvlRecord.i?'ON':'OFF'}`")
          map-hud(label="Time",:value="getFormattedTime(currentAvlRecord.t)")
</template>
<script>

import mapboxgl from "mapbox-gl";
import { lineString } from "@turf/helpers";
import bbox from "@turf/bbox";
import centroid from "@turf/centroid";
const turf = { bbox, centroid, lineString };
import ChartProgressBar from "@/modules/maps/components/charts/ChartProgressBar.vue";
import moment from "moment/moment";
import MapHud from "@/modules/maps/components/ui/hud/MapHud.vue";
import ChartTimelineGraph from "@/modules/maps/components/charts/ChartTimelineGraph.vue";

export default {
  props: {
    height: null,
  },
  components: {
    ChartTimelineGraph,
    MapHud,
    ChartProgressBar
  },
  data: () => ({
    mapLoaded: false,
    oneLine: null,
    vehicleMarker: null,
    mapTimelineKey: 0,
    timelinePopup: null,

    // items for progress bar
  }),

  computed: {


    getButtonXpos: function () {
      if (this.isDragging) {
        return this.x;
      } else {
        return (this.value / 100) * this.lineWidth;
      }
    },
    avlDataList: function () {
      return this.$store.state.timeline.avl_data;
    },

    currentAvlRecord: function () {
      return this.$store.state.timeline.avlRecord;
    },


    thePercentage: {
      get: function () {
        return this.$store.state.timeline.percentage;
      },
      set: function (value) {
        this.$store.commit("timeline/setPercentage", {percentage: value, avlRecord: this.avlDataItemFromIndex()})
      }
    }

  },
  watch: {
    avlDataList: function (avlArray) {
      // console.log(avlArray)
      this.LineArray = [];

      if (avlArray.length == 0) {
        return
      }



      for (let i = 0; i < avlArray.length; i++) {
        this.LineArray.push([avlArray[i].loc.lon, avlArray[i].loc.lat])
      }

      if (this.LineArray.length > 1) {
        this.oneLine = turf.lineString(this.LineArray);

        if (this.mapLoaded) {
          this.mapTimeline.getSource('theLine_timeline').setData(this.oneLine);
          this.mapTimeline.getSource('arrow_source_timeline').setData(this.oneLine);
        }
        //resize to bounds
        var bbox = turf.bbox(this.oneLine);
        this.mapTimeline.fitBounds(bbox, {padding: 40})

        // reset the vehicle arrow
        this.vehicleMarker.setLngLat([avlArray[0].loc.lon, avlArray[0].loc.lat]);
        this.vehicleMarker.setRotation(avlArray[0].a);
        // this.timelinePopup.setHTML(`<div>${this.getVehicleIcon()}</div><span style="font-weight: bold">${this.getVehicle().name}</span>`)
        this.timelinePopup .setHTML(`<div>${this.getVehicleIcon()}</div><span style="font-weight: bold">${this.getVehicle().name}</span><br>${avlArray[0].s} Kph<br/> <div class="d-flex align-center"><div style="width: 12px; height:12px; border-radius: 50%; background-color: ${avlArray[0].i === true? '#00CC00': '#FF0000'}; margin-right: 5px"></div> ${this.getFormattedTime2(avlArray[0].t)}</div>`);
      }else{
        this.timelinePopup.setHTML(`<div>${this.getVehicleIcon()}</div><span style="font-weight: bold">${this.getVehicle().name}</span>`)
      }
    }
  },


  mounted() {

    this.mapTimeline = null;
    this.$nextTick(() => {
      this.createMap();
    });


  },

  beforeDestroy() {
    this.$nextTick(() => {
      if (this.mapTimeline != null) {
        this.mapTimeline.remove();
      }
    });
  },

  methods: {

    getDistance() {
      if (this.avlDataList.length < 2 || this.currentAvlRecord == null) {
        return "-"
      }
      return ((this.currentAvlRecord.o - this.avlDataList[0].o) / 1000.0).toFixed(2)

    },

    getVehicle: function() {
      return  this.$store.getters["vehicles/getVehicleByID"](this.$store.state.timeline.currentVehicleID);
    },
    getVehicleIcon: function () {
      let tempVehicle = this.getVehicle();
      if (tempVehicle != null && tempVehicle.thumbnail_id != null && tempVehicle.thumbnail.thumbnail != null) {
        return `<div ><img src="/media/${tempVehicle.account_id}/${tempVehicle.thumbnail.thumbnail}" style="width:80px;height: 60px; object-fit: cover "></div>`
      }
      return "";
    },

    getFormattedTime(submitted_time) {
      return moment(submitted_time).format("h:mm.ss a, ddd, Do MMM YYYY")
    },

    getFormattedTime2(submitted_time) {
      return moment(submitted_time).format("h:mm.ss a")
    },

    avlDataItemFromIndex: function () {
      let theIndex = Math.round(this.$store.state.timeline.percentage / 100.0 * this.avlDataList.length)

      if (theIndex >= this.avlDataList.length - 1) {
        theIndex = this.avlDataList.length - 2;
      }

      // set the popoup
      this.timelinePopup .setHTML(`<div>${this.getVehicleIcon()}</div><span style="font-weight: bold">${this.getVehicle().name}</span><br>${this.avlDataList[theIndex].s} Kph<br/>Trip: ${this.getDistance()} Km<br/><div class="d-flex align-center"><div style="width: 12px; height:12px; border-radius: 50%; background-color: ${this.avlDataList[theIndex].i === true? '#00CC00': '#FF0000'}; margin-right: 5px"></div> ${this.getFormattedTime2(this.avlDataList[theIndex].t)}</div>`);



      // console.log(this.avlDataList[theIndex])
      this.vehicleMarker.setLngLat([this.avlDataList[theIndex].loc.lon, this.avlDataList[theIndex].loc.lat]);
      // console.log(this.avlDataList[theIndex].a)
      this.vehicleMarker.setRotation(this.avlDataList[theIndex].a);
      // set the Marker


      return this.avlDataList[theIndex];
    },
    createMap: function () {
      mapboxgl.accessToken =
          "pk.eyJ1IjoibXVnYW1iaWtpbWF0aGkiLCJhIjoiY2p0OWNjaGZxMDdsdjQ0cXZjZTRhZnA0aSJ9.3b3qa7uHHInxWL3TBiMsSQ";
      this.mapTimeline = new mapboxgl.Map({
        container: "mapTimeline",
        style: (this.$store.state.tracks.mapVectorStyle)?"mapbox://styles/mapbox/streets-v10":"mapbox://styles/mapbox/satellite-streets-v12",
        minzoom: 1.3,
        center: [36.8371433, -1.32593], // Nairobi
        zoom: 16
      });

      //Marker for Vehicle
      let el = document.createElement("div");

      el.setAttribute(
          "style",
        `background-image:url("/static/web/markers/${this.$store.state.tracks.mapVectorStyle?'marker_green_translucent.png':'marker_green_translucent_whitebg.png'}");width:80px;height:80px;background-size:80px 80px;background-position: center center;`
      );


      this.vehicleMarker = new mapboxgl.Marker(el);

      this.vehicleMarker.setLngLat([36.8371433, -1.32593]);
      if (this.avlDataList.length > 0) {
        this.vehicleMarker.setLngLat([this.avlDataList[0].loc.lon, this.avlDataList[0].loc.lat]);
        this.vehicleMarker.setRotation(this.avlDataList[0].a);
      }
      this.timelinePopup = new mapboxgl.Popup({ offset: 25 });

      if(this.currentAvlRecord == null){
        this.timelinePopup .setHTML(`<div>${this.getVehicleIcon()}</div><span style="font-weight: bold">${this.getVehicle().name}</span>`)
      }else{
        this.timelinePopup .setHTML(`<div>${this.getVehicleIcon()}</div><span style="font-weight: bold">${this.getVehicle().name}</span><br>${this.currentAvlRecord.s} Kph<br/> <div class="d-flex align-center"><div style="width: 12px; height:12px; border-radius: 50%; background-color: ${this.currentAvlRecord.i === true? '#00CC00': '#FF0000'}; margin-right: 5px"></div> ${this.getFormattedTime2(this.currentAvlRecord.t)}</div>`);
      }

      this.vehicleMarker.setPopup(this.timelinePopup)




      this.mapTimeline.on("load", this.onLoadMap);
    },

    onLoadMap: function () {
      // -- location is lat
      let lat = this.$store.getters["vehicles/devices/getCurrentDevice"].last_location_point.lat;
      let lon = this.$store.getters["vehicles/devices/getCurrentDevice"].last_location_point.lon;
      if (lat == 0 || lon == 0){
        lat = -1.32593;
        lon = 36.8371433;
      }

      // -- timeline Areas
      this.mapTimeline.addSource('timeline_timeline', {
        'type': 'geojson',
        'data': '/api/timeline/geoJSONCollection'
      });

      this.mapTimeline.addLayer({
        'id': 'timeline_fill',
        'type': 'fill',
        'source': 'timeline_timeline', // reference the data source
        'layout': {},
        'paint': {
          'fill-color': '#0d97f7', // blue color fill
          'fill-opacity': 0.3,

        }
      });

      this.mapTimeline.addLayer({
        'id': 'timeline_line',
        'type': 'line',
        'source': 'timeline_timeline', // reference the data source
        'layout': {},
        'paint': {
          "line-color": "#000f4e",
          "line-width": 2,

        }
      });

      this.mapTimeline.on('mouseenter', 'timeline_fill', (e) => {

        // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        // }

        // console.log(`mouse enter ${e.features[0].properties.name} at loc ${e.features[0].properties}`)
        let centroidCoord = [36.76132069660187, -1.2985446867349744]

        let theGeometry = JSON.parse(e.features[0].properties.geometry)
        if (theGeometry.type == "Point") {
          centroidCoord = theGeometry.coordinates;
        } else {
          let centroid = turf.centroid(e.features[0]);
          centroidCoord = centroid.geometry.coordinates;
        }


        this.timelinePopup = new mapboxgl.Popup({closeButton: false})
            .setLngLat(centroidCoord)
            .setHTML(`<i>timeline:</i><br/><b>${e.features[0].properties.name}</b><br/>${e.features[0].properties.description ?? ""}`)
        this.timelinePopup.addTo(this.mapTimeline)
      });

      this.mapTimeline.on('mouseleave', 'timeline_fill', () => {
        this.timelinePopup.remove()
      });


      //-- End timeline Areas


      this.LineArray = [];


      if (this.avlDataList.length < 2) {
        // initialize line array with same position
        this.lineArray = [lon, lat],[lon, lat]
      }else{
        // has Data Points
        for (let i = 0; i < this.avlDataList.length; i++) {
          this.LineArray.push([this.avlDataList[i].loc.lon, this.avlDataList[i].loc.lat])
        }
      }



      // return function if cordinates are not found
      if (this.LineArray.length < 2){

        this.oneLine = turf.lineString([[lon, lat],[lon, lat]]);
        this.vehicleMarker.setLngLat([lon, lat]);
      }else{
        this.oneLine = turf.lineString(this.LineArray);
      }



      // path for arrow
      this.geoPath = {
        type: "geojson",
        data: {
          type: "Feature",
          properties: {},
          geometry: {
            type: "LineString",
            coordinates: []
          }
        }
      };
      this.mapTimeline.addSource('arrow_source_timeline', this.geoPath)

      // Line Source
      this.geoLineSource = {
        id: "theLine_timeline",
        source: {
          type: "geojson",
          data: this.oneLine
        },
        type: "line",
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#ed6498",
          "line-width": 4,
          "line-opacity": 1
        }
      }


      this.mapTimeline.addLayer(this.geoLineSource)

      let zMap = this.mapTimeline
      this.mapTimeline.loadImage("/static/web/arrow.png", function (err, image) {
        // Throw an error if something went wrong
        if (err) throw err;

        // Declare the image
        zMap.addImage("pattern", image);

        // Use it
        zMap.addLayer({
          id: "pattern-layer",
          type: "line",
          source: "arrow_source_timeline",
          paint: {
            "line-pattern": "pattern",
            "line-width": 20,
          },
        });
      });


      // update arrows
      this.mapTimeline.getSource('arrow_source_timeline').setData(this.oneLine);

      //resize to bounds
      var bbox = turf.bbox(this.oneLine);
      this.mapTimeline.fitBounds(bbox, {padding: 40})


      this.vehicleMarker.addTo(this.mapTimeline)
      this.mapLoaded = true;
      this.vehicleMarker.togglePopup();
    }

  }
};
</script>
<style scoped lang="stylus">
.timeline {
  width: 100%;
  position: relative
}

.hud {
  position :absolute;
  top:20px;
  right:40px;
  font-size: 14px;
}

.instructions {
  position :absolute;
  top :5px;
  right :30px;
}

.vehicleLimit {
  position :absolute;
  top :5px;
  left: 30px;
}

.testBtn {
  position :absolute;
  top: 60px;
  left: 100px;
  z-index: 100
}
.myMarker{
  background-image: url('/static/web/markers/marker_green_translucent.png');
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
</style>
